// @mui material components
import Grid from "@mui/material/Grid";
import RefreshIcon from "@mui/icons-material/Refresh";

// formik components
import { useFormikContext } from "formik";
import { useFormAnalyticsContext } from "contexts/contextFormAnalytics";

// Material Dashboard 2 PRO React TS components
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";

import FormField from "components/FormField";

function SurvivalLastYearForm({ formData }: any): JSX.Element {
  const { formField, values, errors, touched } = formData;
  const { survivalLastYearAge1, survivalLastYearAge2, survivalLastYearAge3, survivalLastYearAge4 } =
    formField;

  const { countryDefaults } = useFormAnalyticsContext();
  const { setValues } = useFormikContext<any>();

  const resetValues = () => {
    setValues((prev: any) => ({
      ...prev,
      survivalLastYearAge1: countryDefaults?.survivalLastYearAge1 ?? prev.survivalLastYearAge1,
      survivalLastYearAge2: countryDefaults?.survivalLastYearAge2 ?? prev.survivalLastYearAge2,
      survivalLastYearAge3: countryDefaults?.survivalLastYearAge3 ?? prev.survivalLastYearAge3,
      survivalLastYearAge4: countryDefaults?.survivalLastYearAge4 ?? prev.survivalLastYearAge4,
    }));
  };

  return (
    <MDBox>
      <Grid container alignItems="center" justifyContent={"space-between"}>
        <Grid item xs={10}>
          <MDTypography variant="h6">Relative survival in 2049: </MDTypography>
        </Grid>
        <Grid item xs={2}>
          <MDButton
            variant="gradient"
            color="dark"
            size="small"
            iconOnly
            onClick={() => resetValues()}
          >
            <RefreshIcon />
          </MDButton>
        </Grid>
        <Grid item xs={3}>
          <MDTypography variant="caption">{values.ageIntervalStart1}</MDTypography>
          <FormField
            type={survivalLastYearAge1.type}
            label={survivalLastYearAge1.label}
            name={survivalLastYearAge1.name}
            value={values.survivalLastYearAge1}
            placeholder={survivalLastYearAge1.placeholder}
            error={errors.survivalLastYearAge1 && touched.survivalLastYearAge1}
            precision={3}
          />
        </Grid>
        <Grid item xs={3}>
          <MDTypography variant="caption">{values.ageIntervalStart2}</MDTypography>
          <FormField
            type={survivalLastYearAge2.type}
            label={survivalLastYearAge2.label}
            name={survivalLastYearAge2.name}
            value={values.survivalLastYearAge2}
            placeholder={survivalLastYearAge2.placeholder}
            error={errors.survivalLastYearAge2 && touched.survivalLastYearAge2}
            precision={3}
          />
        </Grid>
        <Grid item xs={3}>
          <MDTypography variant="caption">{values.ageIntervalStart3}</MDTypography>
          <FormField
            type={survivalLastYearAge3.type}
            label={survivalLastYearAge3.label}
            name={survivalLastYearAge3.name}
            value={values.survivalLastYearAge3}
            placeholder={survivalLastYearAge3.placeholder}
            error={errors.survivalLastYearAge3 && touched.survivalLastYearAge3}
            precision={3}
          />
        </Grid>
        <Grid item xs={3}>
          <MDTypography variant="caption">{values.ageIntervalStart4}</MDTypography>
          <FormField
            type={survivalLastYearAge4.type}
            label={survivalLastYearAge4.label}
            name={survivalLastYearAge4.name}
            value={values.survivalLastYearAge4}
            placeholder={survivalLastYearAge4.placeholder}
            error={errors.survivalLastYearAge4 && touched.survivalLastYearAge4}
            precision={3}
          />
        </Grid>
        <Grid item xs={12}>
          <MDTypography
            variant="caption"
            color="error"
            fontWeight="regular"
            sx={{ whiteSpace: "pre-wrap" }}
          >
            {errors.survivalLastYearAge1 ||
              errors.survivalLastYearAge2 ||
              errors.survivalLastYearAge3 ||
              errors.survivalLastYearAge4}
          </MDTypography>
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default SurvivalLastYearForm;
